/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import "./Section.scss";
import { cn } from "tailwind-variants";

export default function Section({ children, ...restProps }: any) {
  return (
    <div {...restProps} className={cn("scope-07d524f7", restProps.className, "section")}>
      {children}
    </div>
  );
}
